import React from "react";
import {Col, Row, Card} from "antd";
import purchasesApi from '@api/purchase'
import PurchasesReportSearch from '@components/purchases/dashboard/Search';
import ReportsPurchaseChart from '@components/purchases/dashboard/PurchaseChart';
import ReportsCountChart from '@components/purchases/dashboard/CountChart';
import ReportList from '@components/purchases/dashboard/List';
import {PurchaseStatus} from "../../models/purchase";
import whitListData from "../../hocs/withListData";
import withPaginationComponent from "../../hocs/withPaginationComponent";
import {useSelector} from "react-redux";
import {getMainClientId} from "../../components/clients/selectors";




function useListFilter() {
  const client_id = useSelector(getMainClientId);
  return {
    client_id,
    status : PurchaseStatus.Success
  }
}

function PurchasesDashboardPage(props) {
  const { data, isFetched, search} = props;
  
  return (
    <Row gutter={16}>
      <Col span={24}>
        <Card className={`page-table-header`} bordered={false}>
          <PurchasesReportSearch search={search}/>
        </Card>
      </Col>
      <Col span={24}>
        {data.length > 0 && (
          <Row gutter={12}>
            <Col span={12}>
              <ReportsPurchaseChart data={data}/>
            </Col>
            <Col span={12}>
              <ReportsCountChart data={data}/>
            </Col>
          </Row>
        )}
        
        <ReportList
          loading={!isFetched}
          data={data}/>
      </Col>
    </Row>
  )
}



export default whitListData(
  withPaginationComponent(PurchasesDashboardPage),
  {
    fetchRequest: purchasesApi.getStatistics,
    paginationOnScroll: false,
    useFilter: useListFilter
  }
);

